import { LoaderSimple } from '@components/loader/loader-simple';

export const Loader = () => {
  return (
    <div className='w-full h-full flex justify-center items-center'>
      <div className='w-40 h-40 text-primary'>
        <LoaderSimple />
      </div>
    </div>
  );
};
